import { render, staticRenderFns } from "./showStartUp.vue?vue&type=template&id=6d8e8849"
import script from "./showStartUp.vue?vue&type=script&lang=js"
export * from "./showStartUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports